import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f147a2c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=f147a2c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f147a2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f147a2c6')) {
      api.createRecord('f147a2c6', component.options)
    } else {
      api.reload('f147a2c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f147a2c6&scoped=true", function () {
      api.rerender('f147a2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message-template/index.vue"
export default component.exports